module.exports = __webpack_public_path__ + "img/pesaj-2017.94cfbc34.jpg";